import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import InitiativesPage from './Pages/InitiativesPage';
import ErrorPage from './Pages/ErrorPage';
import { Provider as ReduxProvider } from 'react-redux';
import { persistor, store } from './Store/Store';
import LoginPage from './Pages/LoginPage';
import UsersPage from './Pages/UsersPage';
import { ClientPage } from './Pages/ClientPage';
import { IntegrityPage } from './Pages/IntegrityPage';
import { PersistGate } from 'redux-persist/integration/react';
import { ResetPasswordPage } from './Pages/ResetPasswordPage';
import { UserAccountPage } from './Pages/UserAccountPage';
import { ClientAccountPage } from './Pages/ClientAccountPage';
import { InitiativeDetailPage } from './Pages/InitiativeDetailPage';
import { InitiativeCopyPage } from './Pages/InitiativeCopyPage';
import { ClientDashboardPage } from './Pages/ClientDashboardPage';
import { InitiativeDashboardPage } from './Pages/InitiativeDashboardPage';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        path: '/Login',
        element: <LoginPage />,
        errorElement: <ErrorPage />,
      },
      {
        path: '/Initiatives',
        element: <InitiativesPage />,
        errorElement: <ErrorPage />,
      },
      {
        path: '/Users',
        element: <UsersPage />,
        errorElement: <ErrorPage />
      },
      {
        path: '/Integrity',
        element: <IntegrityPage />,
        errorElement: <ErrorPage />
      },
      {
        path: '/ClientPage',
        element: <ClientPage />,
        errorElement: <ErrorPage />
      },
      {
        path: '/ResetPassword',
        element: <ResetPasswordPage />,
        errorElement: <ErrorPage />
      },
      {
        path: '/UserAccount',
        element: <UserAccountPage />,
        errorElement: <ErrorPage />
      },
      {
        path: '/ClientAccount',
        element: <ClientAccountPage />,
        errorElement: <ErrorPage />
      },
      {
        path: '/InitiativeDetail',
        element: <InitiativeDetailPage />,
        errorElement: <ErrorPage />
      },
      {
        path: '/InitiativeCopy',
        element: <InitiativeCopyPage />,
        errorElement: <ErrorPage />
      },
      {
        path: '/ClientDashboard',
        element: <ClientDashboardPage />,
        errorElement: <ErrorPage />
      },
      {
        path: '/InitiativeDashboard',
        element: <InitiativeDashboardPage />,
        errorElement: <ErrorPage />
      }
    ]
  }
])
root.render(
  <>
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <RouterProvider router={router} />
      </PersistGate>
    </ReduxProvider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
